if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");
	
	linkTag.rel = "stylesheet";
	linkTag.type="text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}

	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	
	if (oldTag) {
  oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
} else {
  document.head.appendChild(linkTag);
}
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {
"vendors-node_modules_mui_icons-material_esm_Add_js-node_modules_mui_icons-material_esm_ArrowB-ea3de4": 1,
"src_pages_Providers_View_tsx-src_features_dashboard_styles_PulsingDot_css": 1,
"src_pages_Providers_Create_tsx-src_features_dashboard_styles_PulsingDot_css": 1,
"node_modules_mui_material_RadioGroup_RadioGroup_js-src_pages_Integrations_index_tsx": 1,
"src_pages_Meters_MeterJobs_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_ApplicationGroups_index_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_ApplicationGroups_Create_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_ApplicationGroups_View_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Applications_index_tsx-src_features_dashboard_styles_PulsingDot_css": 1,
"src_pages_Applications_View_tsx-src_features_dashboard_styles_PulsingDot_css": 1,
"src_pages_Accounts_index_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Accounts_Create_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Accounts_View_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Tariffs_index_tsx-src_features_dashboard_styles_PulsingDot_css": 1,
"src_pages_Tariffs_Create_tsx-src_features_dashboard_styles_PulsingDot_css": 1,
"src_pages_Tariffs_View_tsx-src_features_dashboard_styles_PulsingDot_css": 1,
"src_pages_Utilities_Create_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Utilities_View_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Sensors_index_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Sensors_View_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Meters_index_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Meters_Create_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Meters_View_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_UnallocatedDevices_UnallocatedDevices_tsx-node_modules_leaflet-geosearch_dist_geose-65e0cc": 1,
"src_pages_MeterPoints_index_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_MeterPoints_Create_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_MeterPoints_View_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"src_pages_Gateways_View_tsx-node_modules_leaflet-geosearch_dist_geosearch_css": 1,
"node_modules_mui_icons-material_esm_ArrowBack_js-src_features_gateways_utils_gatewayModels_ts-b27994": 1,
"vendors-node_modules_vis-timeline_styles_vis-timeline-graph2d_css": 1,
"vendors-node_modules_mui_material_colors_teal_js-node_modules_xyflow_react_dist_style_css-nod-c39456": 1,

};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function() {
					installedCssChunks[chunkId] = 0;
				},
				function(e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,

				/**
					If dynamically add link tag through dom API and there is already a loaded style link, browsers sometimes treats the new link tag as the same link, and won't fetch the new style.
					Use query to avoid browser cache the link tag, force to re-fetch new style, this is the same strategy as updateCss API, this can happen during lazy compilation
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

